module.exports = __webpack_public_path__ + "static/siteHeader-a80902d76273ddbeca5c1bd4efd8073f.png";